import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';
import Nomenclatures from "@/module/store/nomenclatures"
import storeWorkingSpace from "@/module/store/workingspace"

import {iNomCategOfEvents} from '@/types/iNomCategOfEvents';
import {iNomTypesOfEvents} from '@/types/iNomTypesOfEvents';
import  {displayLink}  from '@/module/utils';
import { date } from 'quasar';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {I_List} from "@/types/iList";
import GiftsList from "@/components/GiftsList/GiftsList"
import PartakersList from "@/components/PartakersList/PartakersList"
import LastsPublicLists from "@/components/LastsPublicLists/LastsPublicLists"
import EditImageForList from "@/components/EditImageForList/EditImageForList"
import GiftIdeas from "@/components/GiftIdeas/GiftIdeas"
import { VOverdrive } from 'vue-overdrive';
import { scroll } from 'quasar';
const { getScrollTarget, setScrollPosition } = scroll;

interface I_AjaxResponse_GetListDetails{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        list_header:I_List
    }
}



@Component({components:{GiftsList,PartakersList,LastsPublicLists,GiftIdeas,EditImageForList,'overdrive': VOverdrive}})
export default class WorksAList extends Vue {
    @Prop() listid!: number;
    @Prop() m!:string;//mode edit or mode view
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    dialogEditDetailForList:boolean=false;
    xsm:string='xsm';
    sizelg:string='lg';
    dialogAddChildToList:boolean=false;
    currentChildComponent:string='';
    childid_for_edit:number=0;
    displayInFront:string='gifts';
    moveInFront:string='gifts';
    listHeader:I_List={
        userid:0,
        listid:0,
        list_name:'',
        name_of_titular_event:'',
        type_of_event:0,
        contact_phone:'',
        event_time:'',
        event_time_data:'',
        event_time_ora:'',
        privacy_type:'',
        password_list:'',
        description:'',
        location_county:'',
        location_city:'',
        location_street:'',
        location_text:'',
        type_of_titular_event:'',
        status:'',
        url_for_img:'',
        has_attached_image:''
    }

    $refs:any;
    private userStore=getModule(User)
    private nomenclaturesStore=getModule(Nomenclatures);
    private storeWorkingSpace=getModule(storeWorkingSpace);


    constructor(){
        super();
    }

    goUpperSite(){
        const el: HTMLElement = document.getElementById('img_logo_site')!;
        const target = getScrollTarget(el)
        const offset = el.offsetTop
        const duration = 300;
        setScrollPosition(target, offset, duration);
    }

    displayLink50Chr(pstr:string):string{
        return displayLink(pstr);
    }

    getAwesomeIconForEventType(ptype_id:number):string{
        let event_type=this.nomenclaturesStore.nom_types_of_events.find((pevent_type:iNomTypesOfEvents)=>{
            return pevent_type.type_id==ptype_id
        })
        if(event_type){
            return event_type.icon_awesome;
        }else return '';
    }

    async getListDetailsFromDB(plistid:number){
        const vueInst=this;
        let resFromAjax = await <Promise<I_AjaxResponse_GetListDetails>> axios.get(`${CONFIG_ENV.URL_GIFTS.get_list_details}/${plistid}`);
        vueInst.listHeader.listid=resFromAjax.data.list_header.listid;
        vueInst.listHeader.list_name=resFromAjax.data.list_header.list_name;
        vueInst.storeWorkingSpace.set_current_work_a_list({listid:vueInst.listid,list_name:vueInst.listHeader.list_name});
        vueInst.listHeader.name_of_titular_event=resFromAjax.data.list_header.name_of_titular_event;
        vueInst.listHeader.type_of_event=resFromAjax.data.list_header.type_of_event;
        vueInst.listHeader.contact_phone=resFromAjax.data.list_header.contact_phone;
        vueInst.listHeader.privacy_type=resFromAjax.data.list_header.privacy_type;
        vueInst.listHeader.password_list=resFromAjax.data.list_header.password_list;
        vueInst.listHeader.description=resFromAjax.data.list_header.description;
        vueInst.listHeader.location_county=resFromAjax.data.list_header.location_county;
        vueInst.listHeader.location_city=resFromAjax.data.list_header.location_city;

        vueInst.listHeader.location_street=resFromAjax.data.list_header.location_street;
        vueInst.listHeader.location_text=resFromAjax.data.list_header.location_text;
        vueInst.listHeader.type_of_titular_event=resFromAjax.data.list_header.type_of_titular_event;
        vueInst.listHeader.status=resFromAjax.data.list_header.status;
        vueInst.listHeader.has_attached_image=resFromAjax.data.list_header.has_attached_image;
        vueInst.listHeader.url_for_img=CONFIG_ENV.URL_LISTS.getImageAsAvatarForList+'/'+resFromAjax.data.list_header.listid+'?t='+Math.random();


        let eventDate = date.buildDate({ year:resFromAjax.data.list_header.event_time.substr(0, 4),
                                                month:resFromAjax.data.list_header.event_time.substr(5, 2),
                                                date:resFromAjax.data.list_header.event_time.substr(8, 2),
                                                hours:resFromAjax.data.list_header.event_time.substr(11, 2),
                                                minutes:resFromAjax.data.list_header.event_time.substr(14, 2)
                                                })
        vueInst.listHeader.event_time_data= date.formatDate(eventDate, 'DDMMM,YYYY');
        vueInst.listHeader.event_time_ora= date.formatDate(eventDate, 'HH:mm');
        vueInst.$q.loading.hide();
    }

    formatTextLink(ptext:string):string{
        ptext=ptext.replace("http://", "");
        ptext=ptext.replace("https://", "");
        if (ptext.length>30) {
           return ptext.substring(0, 20) + "..." + ptext.substr(ptext.length - 5);
        }
        else {return ptext;}
    }

    tryToOpenFormAddNewImageToList(plist:I_List){
        this.dialogEditDetailForList=true;
        this.currentChildComponent='EditImageForList';
    }

    nomTypeOfEventForCateg(pcateg_id:number){
        return this.nomenclaturesStore.nom_types_of_events.filter((ptype_of_event:iNomTypesOfEvents)=>{
            return 1*ptype_of_event.categ_id==1*pcateg_id;
        });
    }

    get nomTypeOfEvent(){
        return this.nomenclaturesStore.nom_types_of_events;
    }

    get nomCategOfEvent(){
        return this.nomenclaturesStore.nom_categ_of_events;
    }

    goToMyHomePage(){
        this.$router.push({name: 'my_home_page'})
    }

    fctInParentforActionInDetail(pparams:any) {
        const vueInst = this;
        if (pparams == 'AnImageForListWasUploaded') {
            vueInst.listHeader.has_attached_image = 'y';
            vueInst.listHeader.url_for_img = CONFIG_ENV.URL_LISTS.getImageAsAvatarForList + '/' + vueInst.listHeader.listid + '?t=' + Math.random();
            this.dialogAddChildToList = false;
        }
    }

    activated(){
        const vueInst=this;
            if(vueInst.listid && 1*vueInst.listid>0){
                vueInst.$q.loading.show();
                vueInst.getListDetailsFromDB(vueInst.listid);
                vueInst.goUpperSite();
            }
        else{
                vueInst.$q.notify({
                    color: 'red-5',
                    textColor: 'white',
                    position:'top-right',
                    icon: 'fas fa-exclamation-triangle',
                    message: 'Lipseste identificatorul listei! Apasati F5 si incercati din nou!'
                });
            }
        vueInst.goUpperSite();
    }
}
